export type CommonProps = {
  deeplink: string;
  disabled?: boolean;
  tooltipLabel?: string;
};

export const QUERY_KEY = 'tags';
export const ONE_MINUTE = 1000 * 60 * 1;

export const NEEDL_BOOKMARK_TAG = 'needl_internal_bookmark';
